export default "__VITE_ASSET__BsmA0Wls__"